import { useCallback, useEffect, useState } from 'react';
import { API } from '../../api';
import { PagedResultState } from '../../common/CommonResult';
import queryString from 'query-string';

import {
  Layout,
  Select,
  Space,
  Table,
  TablePaginationConfig,
  Button,
  message,
  Tag,
  Card,
  Input,
  Alert,
} from 'antd';
import { ScanModal } from '../../lib/parcel/ScanModal';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ReloadOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import CustomerSelect from '../../lib/CustomerSelect';

const OrderDraftPackage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchState, changeSearchState] = useState<any>({});
  const [state, changeState] = useState<PagedResultState<any>>({
    loading: true,
    result: {},
  });
  const [query, changeQuery] = useState('');
  const [loadingSync, changeLoadingSync] = useState<string | null>(null);
  const [syncResult, changeSyncResult] = useState<any>({});
  useEffect(() => {
    if (location.search) {
      changeSearchState(queryString.parse(location.search));
      fetchContent(location.search);
    } else {
      navigate(`/order_draft/packages?page=1`);
    }
  }, [location.search, navigate]);
  const changeSearch = useCallback(
    (val: any) => {
      const res = { ...queryString.parse(location.search), ...val };
      navigate(`/order_draft/packages?${queryString.stringify(res)}`);
    },
    [navigate, location]
  );
  const orderDraftSync = useCallback(
    async (packageNumber: string) => {
      if (loadingSync !== null) {
        message.error('Зэрэг уншуулж болохгүй');
        return;
      }
      changeLoadingSync(packageNumber);
      try {
        const response = await API.post({ apiVersion: 'api' })('/order_draft/sync', {
          packageNumber,
        });
        // changeSyncResult(response.result);
      } catch (e: any) {
        message.error(e.message);
      } finally {
        changeLoadingSync(null);
      }
    },
    [loadingSync]
  );
  const fetchContent = async (filter: any) => {
    try {
      changeState({ loading: true, result: {} });
      const response = await API.get({ apiVersion: 'api' })(`/order_draft/package/list${filter}`);
      changeState({ loading: false, result: response.result });
    } catch (e) {
      changeState({ loading: false, error: true, result: {}, errors: e });
    }
  };
  const handleTableChange = (pagination: TablePaginationConfig) => {
    const params = queryString.parse(location.search);
    const search = {
      ...params,
      page: pagination.current || 1,
      size: pagination.pageSize,
    };
    navigate(`/order_draft/packages?${queryString.stringify(search)}`);
  };
  const columns = [
    {
      title: '№',
      dataIndex: 'no',
      width: 70,
    },
    {
      title: 'Богц №',
      dataIndex: 'packageNumber',
      width: 150,
      render: (data: any, row: any) => (
        <Link to={`/order_draft/parcels?page=1&packageNumber=${row.packageNumber}`}>{data}</Link>
      ),
      key: 'packageNumber',
    },
    {
      title: 'Харилцагч',
      dataIndex: 'customer',
      width: 150,
      render: (data: any) => data?.name,
      key: 'customerName',
    },
    {
      title: 'Илгээмж',
      dataIndex: 'parcelCount',
      width: 150,
      key: 'parcelCount',
    },
    {
      title: 'Огноо',
      dataIndex: 'createdAt',
      render: (row: any) => dayjs(row).format('YYYY-MM-DD HH:mm:ss'),
      key: 'createdAt',
    },
    {
      title: 'Action',
      render: (row: any) => (
        <Space wrap>
          <Button
            loading={loadingSync === row.packageNumber}
            onClick={() => orderDraftSync(row.packageNumber)}
            type="primary"
            shape="circle"
            icon={<ReloadOutlined />}
          />
        </Space>
      ),
    },
  ];
  return (
    <Layout.Content style={{ margin: '24px 16px 0' }}>
      <Card
        title={`Урьдчилсан захиалгын богц - ${state.result?.total ?? 0}`}
        extra={
          searchState.manifestNumber && (
            <Tag
              color="green"
              closable
              style={{ userSelect: 'none' }}
              onClose={() => changeSearch({ manifestNumber: undefined })}
            >
              Тээвэр - {searchState.manifestNumber}
            </Tag>
          )
        }
      >
        <Space wrap style={{ marginBottom: 15 }}>
          <Input.Search
            allowClear
            placeholder="Богцны дугаар"
            value={query}
            onChange={(e) => changeQuery(e.target.value)}
            onSearch={(value) => {
              let q = undefined;
              if (value) {
                q = value;
              }
              changeSearch({ query: q });
            }}
            style={{ width: 200 }}
          />
          <CustomerSelect
            showSearch
            defaultQuery={{ type: 'CN' }}
            allowClear
            value={searchState.customer}
            onChange={(e) => changeSearch({ ...searchState, customer: e, page: 1 })}
          />
        </Space>
        {syncResult.total && (
          <Alert
            style={{ marginBottom: 15 }}
            message={`Нийт ${syncResult.total} амжилттай - ${syncResult.success} Хаягийн алдаатай - ${syncResult.fail}`}
            type="success"
            closable
            afterClose={() => changeSyncResult({})}
          />
        )}
        <Table
          pagination={{
            pageSize: state.result.size,
            current: state.result.page,
            total: state.result.total,
          }}
          onChange={handleTableChange}
          loading={state.loading}
          dataSource={state.result.data}
          columns={columns}
          rowKey="no"
        />
      </Card>
      <ScanModal open={false} list={[]} onInsert={(e) => console.log(e)} />
    </Layout.Content>
  );
};
export default OrderDraftPackage;
